import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { hasPermission } from '../../utils/permissions';

export default function PermissionRoute({ module }) {
  const [user] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('authUser'));
    } catch (e) {
      return null;
    }
  });

  if (!hasPermission(user, module)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
